import React from 'react'
import { bindActionCreators } from 'redux'
import * as polyglotActions from '../../../redux/polyglot/actions'
import { connect } from 'react-redux'
import Settings from './Settings'

class SettingsContainer extends React.Component {
  changeLanguage (newLocale) {
    this.props.replaceTranslations(newLocale)
  }
  render () {
    return <Settings currentLocale={this.props.currentLocale} changeLanguage={this.changeLanguage.bind(this)} />
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators(polyglotActions, dispatch)
}

function mapStateToProps ({polyglot}) {
  return {
    currentLocale: polyglot.locale
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsContainer)
